export default __webpack_public_path__ + "static/media/commision.c8e5433c.svg";